module.exports = __webpack_public_path__ + "img/phone.1c130fa6.png";